export const CURRENT_CLIENT_PERSONAL_INFORMATION_EDIT_MODAL_NAME = 'currentClientPersonalInformationEdit';
